import React from "react";
import { useNavigate } from "react-router-dom";
import Btn from "../common/Btn";

const NoData = ({ imgUrl, title, title2 }) => {
  const navigate = useNavigate();

  return (
    <div className="-mt-[132px] flex h-screen flex-col items-center justify-center">
      <div className="text-center">
        <img src={imgUrl} alt="No data" className="mx-auto mb-[42px]" />
        <p className="mb-[48px] text-body3_600 text-gray_160">
          No {title} yet!
          <br />
          Check out {title2} in Meal Plans 👏
        </p>
        <div className="-mx-4">
          <Btn
            bgColor={"bg-main"}
            textColor={"text-white font-semibold"}
            borderColor={"border border-main"}
            title={"Go to Meal Plans"}
            active={"on"}
            onAction={() => {
              window.scrollTo(0, 0);
              navigate(`/recommend`);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default NoData;
